import React from "react";
import { TanstackSortingFn } from "../../../../utils/TableSorting";
import { HiPencil, HiTrash } from "react-icons/hi2";
import BaseTable from "../../../ui/CustomTanStackTable/CustomTanStackTable";
import { getDisplayValue } from "../../../../utils/transactionutils";
function RoleTableTanstack({ data, onEdit, onDelete }) {
  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Role Name",
        cell: (info) => (
          <div
            className="max-w-[160px] truncate"
            title={getDisplayValue(info.getValue())}
          >
            {getDisplayValue(info.getValue())}
          </div>
        ),
        sortingFn: TanstackSortingFn,
      },
      {
        id: "permissionsCount",
        header: "Permissions",
        cell: ({ row }) => (
          <span className="inline-flex items-center gap-1 text-xs text-green-700 font-semibold">
            {row.original.permissions?.length || 0}
          </span>
        ),
        accessorFn: (row) => row.permissions?.length || 0,
        sortingFn: TanstackSortingFn,
      },
      {
        id: "actions",
        header: () => <div className="text-right">Actions</div>,
        cell: (info) => {
          const row = info.row.original;
          return (
            <div className="flex gap-2 justify-end">
              <button
                title="Edit"
                className="text-blue-500 hover:text-blue-700"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit?.(row);
                }}
              >
                <HiPencil size={16} />
              </button>
              <button
                title="Delete"
                className="text-red-500 hover:text-red-700"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete?.(row);
                }}
              >
                <HiTrash size={16} />
              </button>
            </div>
          );
        },
        enableSorting: false,
      },
    ],
    [onEdit, onDelete],
  );

  return (
    <BaseTable
      columns={columns}
      data={data}
      pageSize={pagination.pageSize}
      pagination={pagination}
      onPaginationChange={setPagination}
      paginationMode="client"
      emptyMessage="No Roles Found"
      rowClassName={() =>
        "hover:bg-blue-50 cursor-pointer bg-white-50 h-[50px] "
      }
    />
  );
}

export default RoleTableTanstack;
